var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserDefaultSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 99,
    viewBox: "0 0 98 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3943_11430)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.12207,
    width: 98,
    height: 98,
    rx: 49,
    fill: "#3C3C3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3344 60.512C38.5986 60.512 29.8954 51.2448 29.8954 39.8131C29.8954 28.3814 38.5986 19.1143 49.3344 19.1143C60.0703 19.1143 68.7734 28.3814 68.7734 39.8131C68.7734 51.2448 60.0703 60.512 49.3344 60.512Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2326 84.0411C13.2326 81.297 14.4212 78.7096 16.4567 77.0271L16.4622 77.0212C27.412 68.029 38.3867 63.6083 49.3308 63.6143C60.2777 63.6202 71.2469 68.0497 82.191 77.033L82.1966 77.036C84.2321 78.7126 85.4235 81.3 85.4235 84.0411C85.4346 86.4481 85.4346 90.0023 85.4346 93.0362C85.4346 95.39 84.557 97.6461 82.9936 99.308C81.4329 100.973 79.3141 101.907 77.1036 101.907H21.5636C19.3531 101.907 17.2342 100.973 15.6736 99.308C14.1101 97.6461 13.2326 95.39 13.2326 93.0362V84.0411Z",
    fill: "#E3E3E3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3943_11430"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.12207,
    width: 98,
    height: 98,
    rx: 49,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDefaultSvg);
export default __webpack_public_path__ + "static/media/userDefaultSVG.0d76af526480459bab87061a7e75433e.svg";
export { ForwardRef as ReactComponent };